import { compose, withProps, branch, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { convertGenderList } from '../../../../utils/converters/convertListWithLocalization';
import { actions as countryDetailsActions } from '../../../../redux/data/countryDetails';
import {
  selectIsEirVisitTypeCode,
  selectProgressPatientForm,
  selectProgressVisitTypeCode,
  selectUserDetails,
} from '../../../../redux/appointmentForm/selectors';
import {
  selectCountryOptions,
  selectGenderTypes,
  selectRaceTypes,
  selectEthnicTypes,
} from '../../../../redux/data/selectors';

const mapStateToProps = state => ({
  rawGenderList: selectGenderTypes(state),
  rawRaceList: selectRaceTypes(state),
  rawEthnicityList: selectEthnicTypes(state),
  isEirVisitType: selectIsEirVisitTypeCode(state),
  countryList: selectCountryOptions(state),
  details: selectUserDetails(state),
  patientForm: selectProgressPatientForm(state),
  visitTypeCode: selectProgressVisitTypeCode(state),
});
const mapDispatchToProps = {
  getCountryDetails: countryDetailsActions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(
    ({ formatMessage, rawGenderList, rawRaceList, rawEthnicityList }) => ({
      genderList: convertGenderList(rawGenderList, formatMessage) || [],
      raceList: rawRaceList || [],
      ethnicityList: rawEthnicityList || [],
    }),
  ),
  branch(({ details }) => !details, renderNothing),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentPatientInfo/PatientForm/enhance.js